<template>
    <div :class="phoneClass || 'add-dealer-container'">
        <content-header :title="isEdit ? $t('gatewayPage.modification') : $t('gatewayPage.new')">
        </content-header>
        <div class="dealer-content">
            <div class="floor-title">
                <span class="title">{{isEdit ? $t("gatewayPage.modification") : $t("gatewayPage.new")}}</span>
            </div>
            <div class="info-edit">
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('gatewayPage.eui')}}</p>
                        <el-input v-model="editForm.eui" :placeholder="$t('gatewayPage.eui')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('gatewayPage.name')}}</p>
                        <el-input v-model="editForm.name" :placeholder="$t('gatewayPage.name')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('gatewayPage.lora_band')}}</p>
                        <el-select v-model="editForm.lora_band" :placeholder="$t('message.select')">
                            <el-option
                                v-for="item in loraBandList"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--<div class="check" ><span v-show="checkShow">{{msg}}</span></div>-->
                <div class="operation">
                    <el-button type="primary" @click="updateInfo">
                        {{$t('message.preserved')}}
                    </el-button>
                    <el-button  @click="$router.go(-1)">
                        {{$t('message.cancel')}}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Core from "core/core";
import contentHeader from '../../components/content-header'
import region from "core/region"
import {refresh} from "core/winSize"
// import axios from 'axios';
import REGION from '@/assets/ext/region-code.json';
import i18n from "@/locales";
export default {
    data() {
        return {
            phoneClass: '',
            isEdit: false,
            regionData: [],
            pcc: [],
            regionProps: {
                value: 'name',
                label: 'name'
            },
            editForm: {
                eui: '',          //eui
                name: '',       //网关名称
                lora_band: '',

            },
            gatewayId: 0,
            msg: '',
            loraBandList: [],
        };
    },
    components: {
        contentHeader
    },
    created() {
        refresh(this,'phoneClass-add-dealer-container');
        window.onresize = function(){
            setTimeout(function(){
                refresh(this,'phoneClass-add-dealer-container');
            },10)
        };
    },
    mounted() {
        this.initRegion()
        this.gatewayId = this.$route.query.gateway_id || 0;

        if(this.gatewayId) {
            this.isEdit = true;
            this.getGatewayInfo()

        }else {
            this.isEdit = false;
        }
        this.getLoraBandAll()

    },
    computed: {
    },
    methods: {
	    initRegion() {
            let list = REGION.zh
		    list.map(province => {
			    province.children.map(city => delete city.children)
		    })
		    this.regionData = list
	    },
        // name: '',          //服务商名称
        // contact: '',       //联系人
        // phone: '',         //电话
        // SKFid: '',         //id
        // address: '',       //详细地址
        // emall: '',       //邮箱
        // password: '',      //密码
        // province: '',      //省
        // city: '',          //市
        updateInfo() {
            let info = this.editForm;
            if (info.name && info.eui) {
                if(!this.gatewayId){
                    Core.Api.Gateway.save(this.gatewayId,info.eui,info.name,info.lora_band).then(res => {
                        this.$message.success('新增成功');
                        this.$router.push({path:'/device/gateway'})
                        window.scrollTo(0,0);
                    })
                } else {
                    Core.Api.Gateway.save(this.gatewayId,info.eui,info.name,info.lora_band).then(res => {
                        this.$message.success('修改成功');
                        this.$router.push({path:'/device/gateway'})
                        window.scrollTo(0,0);
                    })
                }
            } else {
                this.$message.error(i18n.t('message.complete_information'));

            }


            // Core.Api.Agent.save(this.dealerId,info.name,info.contact,info.phone,info.province,info.city,
            // info.address,info.SKFid,info.emall,info.password).then( res=>{
            //     console.log(保存成功);
            // }).error(()=>{
            //     console.log(保存失败);
            // })
        },
        getGatewayInfo() {
            Core.Api.Gateway.detail(this.gatewayId).then(res => {
                this.editForm = res;
            })
        },
        getLoraBandAll() {
            this.loadingLoraBand = true;
            console.log()
            setTimeout(() => {
                this.loadingLoraBand = false;
                Core.Api.Fengine.getLoraBandList().then(res => {
                    this.loraBandList = res.list
                })
            }, 200);

        },

    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.add-dealer-container {
    height: 100%;
    background-color: #F7F9FA;
    .dealer-content {
        margin: 30px 13vw;
        .floor-title {
            @include flex-sb;
            margin-bottom: 20px;
            .title {
                font-weight: 500;
                font-size: 20px;
                color: #363D42;
            }
            .my-button {
                border-color: #0F58D6;
                .icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                }
                .text {
                    font-size: 14px;
                    color: #0F58D6;
                    vertical-align: middle;
                    line-height: 20px;
                    margin-left: 6px;
                }
            }
        }
        .info-edit {
            .info-floor {
                margin-bottom: 20px;
                .floor-block {
                    display: inline-block;
                    width: calc(50% - 60px);
                    p {
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #7A8799;
                    }
                    &:first-child {
                        margin-right: 2.5vw;
                    }
                }
            }
            .inner-floor-title {
                padding: 10px 0;
                margin-bottom: 20px;
                border-bottom: #EBEDF3 1px solid;
                h2 {
                    font-size: 14px;
                    color: #363D42;
                }
            }
            .operation {
                margin-top: 30px;
                .el-button {
                    padding: 9px 42px;
                }
            }
        }
    }
    .check {
        color: red;
        font-size: 12px;
        position: relative;
        top: -15px;
        left: 15px;
        height: 20px;
    }
}
.phoneClass-add-dealer-container {
    .dealer-content {
        width: 80%;
        margin: 30px auto;
        .floor-title {
            .title {
                font-weight: 500;
                font-size: 20px;
                color: #363D42;
            }
            margin-bottom: 10px;
        }
        .info-edit {
            .floor-block {
                margin-bottom: 7px;
                p {
                    font-size: 14px;
                    color: #7A8799;
                    margin-bottom: 3px;
                }
                .el-select{
                    width: 100%;
                }
            }
        }
        .inner-floor-title {
            margin: 10px 0;
        }
        .operation {
            margin: 20px 0;
        }
    }
}
</style>

<style lang="scss">
.add-dealer-container {
    .info-edit {
        .info-floor {
            .el-input {
                height: 40px;
                .el-input__inner {
                    height: 40px;
                }
            }
            .el-select{
                width: 100%;
            }
        }
    }

}
.phoneClass-add-dealer-container {
    .info-edit {
        .info-floor {
            .el-input {
                height: 30px;
                .el-input__inner {
                    height: 30px;
                }
            }
            .el-select{
                width: 100%;
            }
        }
    }
}
</style>
